<template>
    <footer class="footer pt-10 pb-5 mt-auto bg-dark footer-light d-print-none">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="row">
                        <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                             <div class="footer-brand"><img src="../assets/ICN_Logo.png"></div>
                            <div class="mb-3">MyICNHome is brought to you by <a href="https://www.improvecarenow.org" target="_blank" class="text-reset" onclick="dataLayer.push({'event': 'footer-whatisICN-link'});">ImproveCareNow&trade;</a></div>
                        </div>
                        <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                            <div class="text-uppercase-expanded text-xs mb-0">Social Feed</div>
                            <iframe src="https://www.powr.io/social-feed/u/f26bab3f_1608098375#platform=iframe" style="width:100%;" height="200px" frameborder="0" onclick="dataLayer.push({'event': 'footer-social-feed'});"></iframe>
                        </div>
                        <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                            <div class="text-uppercase-expanded text-xs mb-4">Experience</div>
                            <ul class="list-unstyled mb-0">
                                <li class="mb-2"><router-link to="/" onclick="dataLayer.push({'event': 'footer-home-nav'});">Home</router-link></li>
                                <!-- <li class="mb-2"><a href="javascript:void(0);">Community</a></li> -->
                                <li class="mb-2"><router-link to="/resource-list" onclick="dataLayer.push({'event': 'footer-resources-nav'});">Resources</router-link></li>
                                <li class="mb-2"><router-link to="/support" onclick="dataLayer.push({'event': 'footer-support-nav'});">Support</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-3 col-md-6 mb-5 mb-md-0">
                            <div class="text-uppercase-expanded text-xs ml-4 mb-4">Social Media</div>
                            <div class="icon-list-social mb-5">
                                <iframe src="https://www.powr.io/social-media-icons/u/11032ea8_1608124422#platform=iframe" style="width:100%;" height="49px" frameborder="0" onclick="dataLayer.push({'event': 'footer-social-follow-icon'});"></iframe>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <hr class="my-3" />
            <div class="row align-items-center">
                <div class="col-md-6 small"><a href="https://www.improvecarenow.org/copyright-notice" target="_blank" class="text-reset" onclick="dataLayer.push({'event': 'footer-copyright-link'});">Copyright Notice</a> &#xA9; myICNhome 2020</div>
            </div>
        </div>
    </footer>
</template>
